module.exports = __webpack_public_path__ + "02651adb78ecefd80a5198d998b354e9.svg";